export default __webpack_public_path__ + "static/media/bg2.ecb867d9.png";